/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<mask id="svgicon_edit-filled_a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="2" y="1" width="17" height="17"><path pid="0" d="M15.345 1.667a.83.83 0 00-.59.244l-1.422 1.422 3.334 3.334 1.422-1.423a.833.833 0 000-1.178L15.934 1.91a.83.83 0 00-.589-.244zm-3.262 2.916L2.5 14.167V17.5h3.333l9.584-9.583-3.334-3.334z" _fill="#fff"/></mask><g mask="url(#svgicon_edit-filled_a)"><path pid="1" d="M15.345 1.667a.83.83 0 00-.59.244l-1.422 1.422 3.334 3.334 1.422-1.423a.833.833 0 000-1.178L15.934 1.91a.83.83 0 00-.589-.244zm-3.262 2.916L2.5 14.167V17.5h3.333l9.584-9.583-3.334-3.334z" _fill="#F4633A"/></g>'
  }
})
